import ModalCollection from './ModalCollection';
export default ModalCollection;
